import * as React from 'react';
import Modal from '@mui/material/Modal';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as breakWorksActions from "../../redux/actions/breakworks";

import BreakReasonTimer from "../break-reason/break-reason-timer";
import { Box } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

function DialogActiveBreakWork(props) {
  const user = props?.userSession?.user;
  const breakreasonactive = props?.breakworks?.breakreasonactive

  const userId = user?.id;
  const locksystemduringbreakwork = user?.locksystemduringbreakwork ?? false;
  const breakreasonactiveId = breakreasonactive?.id;

  const open = React.useMemo(() => {
    return !!breakreasonactiveId && !!userId && locksystemduringbreakwork;
  }, [breakreasonactiveId, userId, locksystemduringbreakwork]);

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown
    >
      <Box sx={style}>
        <BreakReasonTimer
          timerStyleType="page"
          setState={props.setState}
          backgroundColorPage={'rgba(250, 250, 250, 1)'}
        />
      </Box>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  userSession: state.userSession,
  breakworks: state.breakworks,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(breakWorksActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DialogActiveBreakWork);
